(function () {
  'use strict';
  document.querySelectorAll('[data-home-premium]').forEach(function (root) {
    var slides = Array.from(root.querySelectorAll('[data-home-hero-slide]'));
    var status = root.querySelector('[data-home-hero-status]');
    var previous = root.querySelector('[data-home-hero-prev]');
    var next = root.querySelector('[data-home-hero-next]');
    if (slides.length < 2 || !status || !previous || !next) return;
    var index = 0;
    var timer;

    function render() {
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      status.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }

    function move(delta) {
      index = (index + delta + slides.length) % slides.length;
      render();
      restart();
    }

    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { move(1); }, 8000);
    }

    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    render();
    restart();
  });
}());
